import Vue from "vue";
import { createTemplateApp } from "@/createTemplateApp";

Vue.prototype.$_variant_modal_button = "v1"; //TODO: нужен файл настройки для таких вещей!

import "@/settings/additional";
import "@/settings/modals";
import "@miku-kz/sprites";

const ModalSafetyRules = () =>
    import(
        /* webpackChunkName: "M_S_R" */ "@main/packages/TheModal/components/ModalSafetyRules"
    );
Vue.component("modal-safety-rules", ModalSafetyRules);

import ThePreloader from "@miku-kz/components/ThePreloader";
Vue.component("preloader", ThePreloader);

import App from "./App";
import mikuKzConfig from "./config";
import { miKuKzMeta } from "./meta";
import { miKuKzRouter } from "./router";
import { mikuKzStores } from "./store";

Vue.config.productionTip = false;

export const createApp = (context) => {
    return createTemplateApp({
        context,
        renderApp: App,
        config: mikuKzConfig,
        metaList: miKuKzMeta,
        routerList: miKuKzRouter,
        storeList: mikuKzStores,
    });
};
